/* LRC dynamic upsell.
   Swaps PRODUCT FACTS ONLY - image, price, variant id, and the product-name
   fallback headline. Leaves the merchant's configured headline, subheadline,
   discount code and button label exactly as set in the theme editor.
   Price math mirrors the Liquid at lrc-custom-checkout-drawer.liquid:358-389. */
(function () {
  function money(c) {
    var n = Number(c) / 100;
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* Resolve {flavor} / {product} / {variant} / {price} against the swapped
     product. {flavor} reads the option NAMED "Flavor" rather than option 1 by
     position, so grind and strength never leak into it. Falls back to option 1
     when no option is named Flavor. */
  function tokenValues(p, variant, finalPriceCents) {
    var flavor = '';
    try {
      var names = (p.options || []).map(function (o) {
        return typeof o === 'string' ? o : (o && o.name) || '';
      });
      var idx = -1;
      for (var i = 0; i < names.length; i++) {
        if (String(names[i]).toLowerCase() === 'flavor') { idx = i; break; }
      }
      if (idx === -1 && names.length) idx = 0;
      if (idx > -1 && variant.options && variant.options[idx]) {
        flavor = variant.options[idx];
      }
    } catch (e) {}
    if (!flavor) flavor = 'this flavor';
    return {
      flavor: flavor,
      product: p.title || '',
      variant: variant.public_title || variant.title || '',
      price: money(finalPriceCents)
    };
  }

  function fillTokens(str, vals) {
    if (!str) return str;
    return String(str)
      .replace(/\{flavor\}/gi, vals.flavor)
      .replace(/\{product\}/gi, vals.product)
      .replace(/\{variant\}/gi, vals.variant)
      .replace(/\{price\}/gi, vals.price);
  }

  /* Find the most recent viewed variant that is in stock and not in the cart.
     Returns {product, variant} or null. Cached per drawer-open. */
  var _cache = {};
  async function findCandidate(cart, onlyHandles) {
    try {
      var ck = String(onlyHandles || '*');
      if (Object.prototype.hasOwnProperty.call(_cache, ck)) {
        var hit = _cache[ck];
        // A cached candidate is still valid only if it has not since entered
        // the cart. Without this check, warming on cart-drawer open could
        // offer an item the shopper added between the two drawers.
        if (!hit) return null;
        if (!cart) return hit;
        var nowInCart = (cart.items || []).some(function (i) {
          return String(i.variant_id) === String(hit.variant.id);
        });
        if (!nowInCart) return hit;
        delete _cache[ck];
      }
      if (!window.LRC_VIEWED) return (_cache[ck] = null);
      var viewed = window.LRC_VIEWED.list();
      if (!viewed.length) return (_cache[ck] = null);

      if (!cart) {
        try { cart = await (await fetch('/cart.js')).json(); } catch (e) { return (_cache[ck] = null); }
      }
      var inCart = {};
      (cart.items || []).forEach(function (i) { inCart[String(i.variant_id)] = 1; });

      // Restrict to a set of product handles when configured. Blank = any.
      var allow = null;
      if (onlyHandles && String(onlyHandles).trim()) {
        allow = {};
        String(onlyHandles).split(',').forEach(function (h) {
          h = h.trim().toLowerCase();
          if (h) allow[h] = 1;
        });
        if (!Object.keys(allow).length) allow = null;
      }

      for (var i = 0; i < viewed.length; i++) {
        var v = viewed[i];
        if (!v.handle || !v.variant_id || inCart[String(v.variant_id)]) continue;
        if (allow && !allow[String(v.handle).toLowerCase()]) continue;

        var p;
        try {
          var r = await fetch('/products/' + encodeURIComponent(v.handle) + '.js');
          if (!r.ok) continue;
          p = await r.json();
        } catch (e) { continue; }

        var variant = (p.variants || []).filter(function (x) {
          return String(x.id) === String(v.variant_id);
        })[0];
        if (!variant || !variant.available) continue;

        var tags = (p.tags || []).map(function (t) { return String(t).toUpperCase(); });
        if (tags.indexOf('NOT FOR PURCHASE') > -1) continue;

        return (_cache[ck] = { product: p, variant: variant });
      }
      return (_cache[ck] = null);
    } catch (e) { return (_cache[ck] = null); }
  }

  /* Preload so the new image paints in one step rather than swapping src on a
     visible element. Resolves either way - never blocks the reveal. */
  function preload(src) {
    return new Promise(function (res) {
      if (!src) return res();
      var im = new Image();
      var done = false;
      var finish = function () { if (!done) { done = true; res(); } };
      im.onload = finish;
      im.onerror = finish;
      setTimeout(finish, 400);
      im.src = src;
    });
  }

  async function swap(block, candidate) {
    try {
      if (!block) return false;
      var c = candidate || await findCandidate(null, block.getAttribute('data-dyn-only-handles'));
      if (!c) return false;
      var src = (c.variant.featured_image && c.variant.featured_image.src) || c.product.featured_image;
      // Apply text/price/button first so the offer is readable at once. The
      // image is already warm from the cart-drawer prefetch in the common case;
      // when it is not, it fades in rather than holding up the whole block.
      apply(block, c.product, c.variant);
      preload(src);
      return true;
    } catch (e) { return false; }
  }

  function apply(block, p, variant) {
    var btn = block.querySelector('button.lrc-drawer-add-to-cart-checkout');

    // ---- image: swap src, switch to contain so nothing is cropped ----
    var img = block.querySelector('#lrc-upsell-product-img');
    var src = (variant.featured_image && variant.featured_image.src) || p.featured_image;
    if (img && src) {
      img.classList.remove('object-cover');
      img.classList.add('object-contain', 'lrc-dyn-img');
      img.src = src;
    }

    // ---- headline: only overwrite when it is the product-name fallback.
    //      A merchant headline (use_custom_headline on) is left alone. ----
    // (token values need the final price, computed below - deferred to applyCopy)

    // ---- price: mirror the Liquid discount math using the block's own
    //      configured discount type and value ----
    var dType = (btn && btn.getAttribute('data-discount-type')) || 'none';
    var dVal = parseFloat((btn && btn.getAttribute('data-discount-value')) || '0') || 0;
    var base = Number(variant.price);
    var finalPrice = base;
    if (dType === 'percent' && dVal > 0) {
      finalPrice = base - Math.round(base * (dVal * 0.01));
    } else if (dType === 'amount' && dVal > 0) {
      finalPrice = base - Math.round(dVal * 100);
    }
    if (finalPrice < 0) finalPrice = 0;

    var struck = variant.compare_at_price ? Number(variant.compare_at_price) : null;
    if (struck === null || struck <= finalPrice) {
      struck = base > finalPrice ? base : null;
    }

    var pr = block.querySelector('.lrc-upsell-price');
    if (pr) pr.textContent = money(finalPrice);

    var cmp = block.querySelector('.lrc-upsell-compare-at-price');
    if (cmp) {
      if (struck !== null && struck > finalPrice) {
        cmp.textContent = money(struck);
        cmp.style.display = '';
      } else {
        cmp.style.display = 'none';
      }
    }

    // ---- discount badge + button label, recomputed for the new price ----
    var badgeType = block.getAttribute('data-dyn-badge-type') || 'none';
    var label = '';
    if (struck !== null && struck > finalPrice && badgeType !== 'none') {
      var savings = struck - finalPrice;
      label = badgeType === 'percent'
        ? Math.round(savings * 100 / struck) + '% OFF'
        : 'SAVE ' + money(savings);
    }

    var badge = block.querySelector('.lrc-discount-badge');
    if (badge) {
      badge.textContent = label;
      badge.style.display = label ? '' : 'none';
    }

    if (btn) {
      btn.setAttribute('data-variant-id', String(variant.id));
      var lbl = btn.querySelector('.lrc-atc-label');
      var base_label = block.getAttribute('data-dyn-btn-label') || 'ADD TO CART';
      var showOnBtn = block.getAttribute('data-dyn-show-discount-btn') === '1';
      if (lbl) lbl.textContent = base_label + (label && showOnBtn ? ' \u2014 ' + label : '');
    }

    // ---- headline + subheadline: fill tokens from the RAW templates the
    //      section published, so repeated swaps never compound ----
    var vals = tokenValues(p, variant, finalPrice);

    var t = block.querySelector('.lrc-upsell-title');
    if (t) {
      var rawH = block.getAttribute('data-dyn-headline-raw');
      if (block.getAttribute('data-dyn-headline-is-product') === '1') {
        t.textContent = p.title;
      } else if (rawH) {
        t.textContent = fillTokens(rawH, vals);
      }
    }

    var st = block.querySelector('#lrc-upsell-subtitle-el');
    if (st) {
      var rawS = block.getAttribute('data-dyn-subtitle-raw');
      if (rawS) {
        var filled = fillTokens(rawS, vals);
        st.textContent = filled;
        st.style.display = filled ? '' : 'none';
      }
    }

    block.setAttribute('data-dyn-applied', String(variant.id));
  }

    /* Warm the candidate + its image ahead of the checkout drawer. Called on
     cart-drawer open and never awaited, so it cannot delay anything. No-ops
     when the page has no dynamic upsell block. */
  var _warmed = false;
  function warm() {
    try {
      if (_warmed) return;
      var blocks = document.querySelectorAll('[data-dynamic-upsell]');
      if (!blocks.length) return;
      _warmed = true;
      var seen = {};
      Array.prototype.forEach.call(blocks, function (b) {
        var only = b.getAttribute('data-dyn-only-handles') || '';
        if (seen[only]) return;
        seen[only] = 1;
        findCandidate(null, only).then(function (c) {
          if (!c) return;
          var s = (c.variant.featured_image && c.variant.featured_image.src) || c.product.featured_image;
          if (s) { var im = new Image(); im.src = s; }
        }).catch(function () {});
      });
    } catch (e) {}
  }

  window.LRC_DYN = {
    swap: swap,
    findCandidate: findCandidate,
    warm: warm,
    resetCache: function () { _cache = {}; _warmed = false; }
  };
})();
